module.exports = __webpack_public_path__ + "static/media/safe.6b21e35c.png";